<ng-container *ngIf="hasViews">
    <st-expansion-panel expanded>
        <ng-container title>{{ languageSettings.PSTWebPlanningViewsPaneLabel }}</ng-container>
        <div class="st-planning-views-expander-items-container">
            <ng-container *ngFor="let rec of views | sort: 'title'">
                <st-planning-view-item [record]="rec" />
            </ng-container>
        </div>
    </st-expansion-panel>
</ng-container>
<ng-container *ngIf="hasSearches">
    <st-expansion-panel expanded>
        <ng-container title>{{ languageSettings.PSTWebSearchesPaneLabel }}</ng-container>
        <div class="st-planning-views-expander-items-container">
            <ng-container *ngFor="let rec of searches | sort: 'title'">
                <st-planning-view-item [record]="rec" />
            </ng-container>
        </div>
    </st-expansion-panel>
</ng-container>

<ng-container *ngIf="hasSlideshows">
    <st-expansion-panel expanded>
        <ng-container title>{{ languageSettings.PSTWebSlideshowsPaneLabel }}</ng-container>
        <div class="st-planning-views-expander-items-container">
            <ng-container *ngFor="let rec of slideshows | sort: 'title'">
                <st-planning-view-item [record]="rec" />
            </ng-container>
        </div>
    </st-expansion-panel>
</ng-container>

<ng-template #mainCta>
    <mat-button-toggle-group class="st-playbook-list-main-cta-button-group">
        <mat-button-toggle
            class="st-playbook-list-button-new-topic"
            (click)="createViewState()">
            <mat-icon class="material-symbols-outlined"> add </mat-icon>
            {{ languageSettings.PSTWebNewLabel }}
        </mat-button-toggle>
    </mat-button-toggle-group>
</ng-template>
